import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "v-asset-name" }

import VAvatar from './VAvatar.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'VAssetName',
  props: {
    item: null
  },
  setup(__props: any) {

const props = __props as { item: { id: string | number, username?: string, picture?: string | null, type_id: number, name?: string, title?: string } }




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(VAvatar, {
      src: props.item.picture,
      type: props.item.type_id
    }, null, 8, ["src", "type"]),
    _createElementVNode("div", null, _toDisplayString(props.item.name || props.item.title || props.item.username || props.item.id), 1)
  ]))
}
}

})